module.exports = __webpack_public_path__ + "static/media/user-solid.a617dfb6.svg";